export default {
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
    /*currentLocale() {
        var objExiste = null;
        if(this.$store.getters["auth/authenticated"]){
            objExiste = _.find(this.$store.getters["app/config"].locales, (o) => o.uuid === this.user.locale_systeme);
        }else{
            objExiste = _.find(this.$store.getters["app/config"].locales, (o) => o.code === this.$store.getters["app/config"].appLocale);
        }
        return objExiste ? objExiste : null;
    },*/
  },
};
